var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { TreeItemView } from "./treeItemView";
export var TreeListView = function (_a) {
    var meta = _a.meta;
    var _b = useState(true), expanded = _b[0], setExpanded = _b[1];
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "relative flex flex-col items-stretch w-full pb-2" }, { children: [_jsxs("span", __assign({ className: "flex flex-row items-center py-2 mb-2 font-bold text-center rounded-md cursor-pointer bg-gray-50", onClick: function (e) {
                        setExpanded(!expanded);
                    } }, { children: [_jsx("span", __assign({ className: "flex-auto" }, { children: "Structure" })), _jsxs("span", __assign({ className: "flex-none mr-4" }, { children: [expanded && (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "w-5 h-5" }, { children: _jsx("path", { d: "M6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z" }) }))), !expanded && (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "w-5 h-5" }, { children: _jsx("path", { d: "M10.75 6.75a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z" }) })))] }))] })), expanded && _jsx(TreeItemView, { meta: meta, level: 0 })] })) }));
};
